import React, { useMemo } from 'react';
import { useTranslation } from '@lib/useTypedTranslation';

import { formatValue } from '../../../../../../components/data-table/dataFormatters';
import { ITableColumn } from '../../../../../../components/data-table/types';
import { getDeviceProcessCrashesSummary } from '../../../../../../services/core/devicePerformance';
import { AnomalySectionProps } from './index';
import { ProcessEventsSection } from './processEventsSection';

export function ProcessCrashesSection(props: AnomalySectionProps) {
  const { t } = useTranslation(['anomalyDetectionBeta']);

  // width: '1%' (see useProcessEventsRawColumns.tsx's own comment) - these are fixed-shape values,
  // not variable-length identifiers, so they shouldn't absorb the Raw Data table's leftover space.
  const eventColumns: ITableColumn[] = useMemo(() => [
    { id: 'exceptionCode', title: t('EXCEPTION_CODE', { ns: 'anomalyDetectionBeta' }), dataPath: 'processCrashInfo.exceptionCode', sortable: true, processor: formatValue, width: '1%' },
    { id: 'exceptionModule', title: t('EXCEPTION_MODULE', { ns: 'anomalyDetectionBeta' }), dataPath: 'processCrashInfo.moduleName', sortable: true, processor: formatValue, width: '1%' }
  ], [t]);

  return (
    <ProcessEventsSection
      {...props}
      eventName="processCrashed"
      rawTableName="deviceAnomalyProcessCrashesRaw"
      summaryTableName="deviceAnomalyProcessCrashesSummary"
      getSummary={getDeviceProcessCrashesSummary}
      titleKey="PROCESS_CRASHES_FOR_RANGE"
      rawStatusTextKey="PROCESS_CRASH_RESULT"
      countColumnTitleKey="NUMBER_OF_CRASHES"
      eventColumns={eventColumns}
      dataId="device-anomaly-examination-process-crashes"
    />
  );
}
